import { Controller } from '@hotwired/stimulus';

import render from './tables/key_decision_maker_module';

export default class KeyDecisionMakersController extends Controller {
  connect(): void {
    render();
  }
}
